import React from "react";
import { useTranslation } from "react-i18next";
import { MenuItem, Select, Box } from "@mui/material";
import useAuthenticatedFetch from "../hooks/useAuthenticatedFetch"; // Hook for authenticated requests
import { useAuth } from "../AuthContext"; // Import authentication context

const LanguageSelector = () => {
  const { t, i18n } = useTranslation(); // Translation hook
  const currentLanguage = i18n.language || "en"; // Current language
  const { user } = useAuth(); // Get user info
  const fetchWithAuth = useAuthenticatedFetch(); // For authenticated requests

  // Language options
  const languages = [
    { code: "en", label: t("language.english"), flag: "🇬🇧" },
    { code: "fr", label: t("language.french"), flag: "🇫🇷" },
    { code: "he", label: t("language.hebrew"), flag: "🇮🇱" },
  ];

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);

    // If the user is logged in, save the language preference on the server
    if (user?.isAuthenticated) {
      fetchWithAuth(`${process.env.REACT_APP_BASE_URL}/user/updateLanguage`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ language: lng }),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(t("language.updateError"));
          }
          return response.json(); // Optional if the backend returns JSON
        })
        .then((data) => {
          console.log(t("language.updateSuccess"), data); // Success message or additional handling
        })
        .catch((error) => {
          console.error(t("language.updateError"), error);
        });
    }
  };

  return (
    <Box>
      <Select
        value={currentLanguage}
        onChange={(e) => changeLanguage(e.target.value)}
        displayEmpty
        sx={{
          minWidth: 120,
        }}
      >
        {languages.map((lang) => (
          <MenuItem key={lang.code} value={lang.code}>
            <span style={{ marginRight: "8px" }}>{lang.flag}</span>
            {lang.label}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
};

export default LanguageSelector;